import {
  ADD_CAMPAIGN_STATUS,
  DELETE_CAMPAIGN_STATUS,
  GET_CAMPAIGN_STATUS_PROFILE,
  GET_CAMPAIGN_STATUSES,
  HIDE_CAMPAIGN_STATUSES_LOADER,
  SET_CAMPAIGN_STATUS_PROFILE,
  SET_CAMPAIGN_STATUSES,
  SET_ERROR_CAMPAIGN_STATUS_PROFILE,
  SHOW_CAMPAIGN_STATUSES_LOADER,
  UPDATE_CAMPAIGN_STATUS_PROFILE
} from "./actionTypes";

export const getCampaignStatusesList = data => ({
  type: GET_CAMPAIGN_STATUSES,
  payload: data
});

export const setCampaignStatusesList = payload => ({
  type: SET_CAMPAIGN_STATUSES,
  payload
});

export const showCampaignStatusesLoader = () => ({
  type: SHOW_CAMPAIGN_STATUSES_LOADER
});

export const hideCampaignStatusesLoader = () => ({
  type: HIDE_CAMPAIGN_STATUSES_LOADER
});

export const addCampaignStatus = (status = {}, data = {}) => ({
  type: ADD_CAMPAIGN_STATUS,
  payload: { status, data }
});

export const deleteCampaignStatus = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_STATUS,
  payload: { id, data }
});

export const getCampaignStatusProfile = id => ({
  type: GET_CAMPAIGN_STATUS_PROFILE,
  payload: id
});

export const setCampaignStatusProfile = payload => ({
  type: SET_CAMPAIGN_STATUS_PROFILE,
  payload
});

export const updateCampaignStatusProfile = (id, status = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_STATUS_PROFILE,
  payload: {id, status, data }
});

export const setCampaignStatusProfileError = payload => ({
  type: SET_ERROR_CAMPAIGN_STATUS_PROFILE,
  payload
});